// custom-date-format.ts
import { MatDateFormats } from '@angular/material/core';

export const MY_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'DD-MM-YYYY', // For user input
  },
  display: {
    dateInput: 'DD-MM-YYYY', // Format in input box
    monthYearLabel: 'MMM YYYY', // Label above calendar
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
